import React from 'react'

import './ThankYouContainer.css';
import { useTranslation } from 'react-i18next';

const ThankYouStep = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="ThankYouComponent">
      <p>{t("We sent you an email with the order confirmation and the link, so you can come back to this page any time.")}</p>
      STEPPER HERE
    </div>
  )
}

export default ThankYouStep